export enum ClientActionType {
  LoadAccount = 'LoadAccount',
  LoadAccountSuccess = 'LoadAccountSuccess',

  LoadLoggedInState = 'LoadLoggedInState',

  LoadAccountContext = 'LoadAccountContext',
  LoadAccountContextSuccess = 'LoadAccountContextSuccess',

  LoadAccountContextSpaces = 'LoadAccountContextSpaces',
  LoadAccountContextSpacesSuccess = 'LoadAccountContextSpacesSuccess',
  LoadAccountContextSpacesFailure = 'LoadAccountContextSpacesFailure',

  LoadAccountContextDatasources = 'LoadAccountContextDatasources',
  LoadAccountContextDatasourcesSuccess = 'LoadAccountContextDatasourcesSuccess',
  LoadAccountContextDatasourcesFailure = 'LoadAccountContextDatasourcesFailure',

  LoadAccountContextFeatures = 'LoadAccountContextFeatures',
  LoadAccountContextFeaturesSuccess = 'LoadAccountContextFeaturesSuccess',
  LoadAccountContextFeaturesFailure = 'LoadAccountContextFeaturesFailure',

  LoadAccountOrganizations = 'LoadAccountOrganizations',
  LoadAccountOrganizationsSuccess = 'LoadAccountOrganizationsSuccess',
  LoadAccountOrganizationsFailure = 'LoadAccountOrganizationsFailure',

  LoadAccountPreference = 'LoadAccountPreference',
  LoadAccountPreferenceSuccess = 'LoadAccountPreferenceSuccess',
  LoadAccountPreferenceFailure = 'LoadAccountPreferenceFailure',

  LoadApi = 'LoadApi',
  LoadApiSuccess = 'LoadApiSuccess',

  LoadApiDatasources = 'LoadApiDatasources',
  LoadApiDatasourcesSuccess = 'LoadApiDatasourcesSuccess',
  LoadApiDatasourcesFailure = 'LoadApiDatasourcesFailure',

  LoadReportContext = 'LoadReportContext',
  LoadReportContextSuccess = 'LoadReportContextSuccess',

  LoadReportContextDatasources = 'LoadReportContextDatasources',
  LoadReportContextDatasourcesSuccess = 'LoadReportContextDatasourcesSuccess',
  LoadReportContextDatasourcesFailure = 'LoadReportContextDatasourcesFailure',

  LoadReportContextFeatures = 'LoadReportContextFeatures',
  LoadReportContextFeaturesSuccess = 'LoadReportContextFeaturesSuccess',
  LoadReportContextFeaturesFailure = 'LoadReportContextFeaturesFailure',

  LoadReport = 'LoadReport',
  LoadReportSuccess = 'LoadReportSuccess',
  LoadReportFailure = 'LoadReportFailure',

  LoadDefinitionSuccess = 'LoadDefinitionSuccess',

  LoadReportCreator = 'LoadReportCreator',
  LoadReportCreatorSuccess = 'LoadReportCreatorSuccess',
  LoadReportCreatorFailure = 'LoadReportCreatorFailure',

  LoadReportEmbeddedSpace = 'LoadReportEmbeddedSpace',
  LoadReportEmbeddedSpaceSuccess = 'LoadReportEmbeddedSpaceSuccess',
  LoadReportEmbeddedSpaceFailure = 'LoadReportEmbeddedSpaceFailure',

  LoadReportRunEmbeddedPdfExport = 'LoadReportRunEmbeddedPdfExport',
  LoadReportRunEmbeddedPdfExportSuccess = 'LoadReportRunEmbeddedPdfExportSuccess',
  LoadReportRunEmbeddedPdfExportFailure = 'LoadReportRunEmbeddedPdfExportFailure',

  LoadReportUserStar = 'LoadReportUserStar',
  LoadReportUserStarSuccess = 'LoadReportUserStarSuccess',
  LoadReportUserStarFailure = 'LoadReportUserStarFailure',

  LoadReportRun = 'LoadReportRun',
  LoadReportRunSuccess = 'LoadReportRunSuccess',

  UpdatePreference = 'UpdatePreference',
  UpdatePreferenceSuccess = 'UpdatePreferenceSuccess',
  UpdatePreferenceFailure = 'UpdatePreferenceFailure',

  ComputeIfUserBelongsToReportContext = 'ComputeIfUserBelongsToReportContext',
}
